module.exports = __webpack_public_path__ + "images/f697c9cb788227fad8bc5196fe13abc4.jpg";